import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { ProtectedRoute } from "./components/layout/ProtectedRoute";
import { CapabilityGuard } from "./components/layout/CapabilityGuard";
import { LoginPage } from "./pages/LoginPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { HomePage } from "./pages/HomePage";
import { ManualPage } from "./pages/ManualPage";
import { ChannelPage } from "./pages/ChannelPage";
import { ProductPage } from "./pages/ProductPage";
import { HistoryPage } from "./pages/HistoryPage";
import { SearchPage } from "./pages/SearchPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { AdminUsersPage } from "./pages/admin/AdminUsersPage";
import { AdminCategoriesPage } from "./pages/admin/AdminCategoriesPage";
import { AdminTagsPage } from "./pages/admin/AdminTagsPage";
import { AdminTechnicalitiesPage } from "./pages/admin/AdminTechnicalitiesPage";
import { AdminCareInstructionsPage } from "./pages/admin/AdminCareInstructionsPage";
import { AdminSizeGuidesPage } from "./pages/admin/AdminSizeGuidesPage";
import { AdminAuditPage } from "./pages/admin/AdminAuditPage";
import { AdminNotificationsPage } from "./pages/admin/AdminNotificationsPage";
import { AdminSettingsPage } from "./pages/admin/AdminSettingsPage";
import { AdminStockPage } from "./pages/admin/AdminStockPage";
import { AdminChannelsPage } from "./pages/admin/AdminChannelsPage";
import { AdminRolesPage } from "./pages/admin/AdminRolesPage";

function Shell({ children }: { children: JSX.Element }): JSX.Element {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/trocar-senha"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />

      <Route path="/" element={<Shell><HomePage /></Shell>} />
      <Route path="/manual" element={<Shell><ManualPage /></Shell>} />
      <Route path="/buscar" element={<Shell><SearchPage /></Shell>} />
      <Route path="/canais/:slug" element={<Shell><ChannelPage /></Shell>} />
      <Route path="/canais/:slug/produtos/:sku" element={<Shell><ProductPage /></Shell>} />
      <Route
        path="/canais/:slug/produtos/:sku/historico"
        element={<Shell><HistoryPage /></Shell>}
      />

      {/* Cada rota exige a capacidade que a tela representa (tabela rota->capacidade
          do plano 2026-09-23 secao 5). super_admin passa sempre (bypass RN23 em
          useAuth().can). Nao ha mais distincao "admin OR super_admin" vs "super
          admin only" fixa no codigo — quem decide e a matriz de /admin/perfis. */}
      <Route
        path="/admin/usuarios"
        element={<Shell><CapabilityGuard need="users.manage"><AdminUsersPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/perfis"
        element={<Shell><CapabilityGuard need="roles.manage"><AdminRolesPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/categorias"
        element={<Shell><CapabilityGuard need="categories.write"><AdminCategoriesPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/tags"
        element={<Shell><CapabilityGuard need="tags.write"><AdminTagsPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/tecnicidades"
        element={<Shell><CapabilityGuard need="technicalities.write"><AdminTechnicalitiesPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/lavagem"
        element={<Shell><CapabilityGuard need="care_instructions.write"><AdminCareInstructionsPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/guias-de-tamanho"
        element={<Shell><CapabilityGuard need="size_guides.write"><AdminSizeGuidesPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/audit"
        element={<Shell><CapabilityGuard need="audit.read"><AdminAuditPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/notificacoes"
        element={<Shell><CapabilityGuard need="notifications.read"><AdminNotificationsPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/estoques"
        element={<Shell><CapabilityGuard need="stock.read"><AdminStockPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/canais"
        element={<Shell><CapabilityGuard need="channels.manage"><AdminChannelsPage /></CapabilityGuard></Shell>}
      />
      <Route
        path="/admin/settings"
        element={<Shell><CapabilityGuard need="settings.manage"><AdminSettingsPage /></CapabilityGuard></Shell>}
      />

      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
